import { navLinks } from "@/mocks/homeContent";

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-movie-2-line" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                榴莲视频
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-900/85 max-w-xl">
              本页为榴莲视频 app 的下载安装说明页，汇总安卓版、苹果版安装包的获取方式、
              最新版更新说明与常见安装问题，帮助你顺利完成下载并进入视频社区。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">页面导航</h4>
            <ul className="mt-4 grid grid-cols-2 gap-y-2 gap-x-4">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-secondary-900/85 hover:text-primary-700 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-900/70">
            © 2026 榴莲视频 · 下载安装指南页
          </p>
          <p className="text-xs text-secondary-900/70">
            安装包与功能以实际发布版本为准
          </p>
        </div>
      </div>
    </footer>
  );
}